import * as React from 'react';
import { Container, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as Roles from 'constants/Roles';

import _ from 'lodash';

import * as Clients from 'client/ApiClient';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';

import 'styles/Forms.scss'
import ApiKeys from './ApiKeys';
import EditUserPage from './EditUser';
import classnames from 'classnames';
import { authentication } from '../../services/Authentication';


interface IUserEditPageProps extends RouteComponentProps<{ userId?: string }> {
    isEditing: boolean;
    isCustomerAdministrator: boolean | undefined;
    isAdministrator: boolean | undefined;
    currentUser: Clients.IUserLoginDetailsModel | undefined,
};

interface UserEditPageState {
    isCurrentUser: boolean;
    tab: string;
    isEditing: boolean;
    user: Clients.UserModel;
    passwordPlaceholder: boolean;
}

type TabName = 'edituser' | 'apikeys' | '';

class UserEditPage extends React.Component<IUserEditPageProps, UserEditPageState> {

    private readonly userClient: Clients.UserClient = new Clients.UserClient();

    constructor(props: IUserEditPageProps) {
        super(props)
        this.state = {
            isCurrentUser: false,
            tab: 'edituser',
            isEditing: !!this.props.match.params.userId,
            user: new Clients.UserModel(),
            passwordPlaceholder: false,
        }
    }

    componentDidMount() {
        if (this.state.isEditing) {
            this.userClient.get(this.props.match.params.userId!)
                .then(response => {
                    if (response) {
                        let isCurrentUser = false;

                        const currentUser = authentication.getCurrentUser();
                        if (response.id === currentUser!.id) {
                            isCurrentUser = true;
                        }
                        this.setState({
                            user: response,
                            passwordPlaceholder: true,
                            isCurrentUser: isCurrentUser
                        });
                    }
                })
                .catch(() => { })
        }
    }

    componentDidUpdate(prevProps: IUserEditPageProps) {
        if (prevProps !== this.props) {
            this.componentDidMount();
        }
    }

    selected = (tab: TabName) => this.state.tab === tab;

    toggle = (tab: TabName) => {
        if (this.state.tab !== tab) {
            this.setState({ tab })
        }
    }

    public render() {
        return (
            <Container>
                {this.state.isCurrentUser && <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('edituser') })}
                            onClick={() => this.toggle('edituser')}>Edit User</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.selected('apikeys') })}
                            onClick={() => this.toggle('apikeys')}>Api Keys</NavLink>
                    </NavItem>
                </Nav>}
                <TabContent activeTab={this.state.tab} className={this.state.tab}>
                    <TabPane tabId='edituser'>
                        <EditUserPage isEditing={this.props.isEditing} user={this.state.user} isCurrentUser={this.state.isCurrentUser} passwordPlaceholder={this.state.passwordPlaceholder} />
                    </TabPane>
                    <TabPane tabId='apikeys'>
                        <ApiKeys id={this.props.currentUser!.id!} />
                    </TabPane>
                </TabContent>
            </Container>
        );
    }
}

export default connect(
    (state: ApplicationState) => {
        return {
            isCustomerAdministrator: state.authentication
                && state.authentication.currentUser
                && state.authentication.currentUser.role === Roles.customerAdministratorRoleId,
            isAdministrator: state.authentication
                && state.authentication.currentUser
                && (state.authentication.currentUser.role === Roles.administrationRoleId
                    || state.authentication.currentUser.role === Roles.developerAdministrationRoleId),
            currentUser: state.authentication
                && state.authentication.currentUser
        }
    },
)(withRouter(UserEditPage));